"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _merge = _interopRequireDefault(require("lodash/merge"));

var _useDebouncedChange3 = _interopRequireDefault(require("./useDebouncedChange"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var toNumber = function toNumber(value) {
  return value === '' ? undefined : parseFloat(value);
};

var eventToValue = function eventToValue(ev) {
  return toNumber(ev.target.value);
};

var MuiInputNumber = /*#__PURE__*/_react["default"].memo(function (props) {
  var data = props.data,
      className = props.className,
      id = props.id,
      enabled = props.enabled,
      uischema = props.uischema,
      path = props.path,
      handleChange = props.handleChange,
      config = props.config,
      startAdornment = props.startAdornment,
      endAdornment = props.endAdornment;
  var inputProps = {
    step: '0.1'
  };
  var appliedUiSchemaOptions = (0, _merge["default"])({}, config, uischema.options);

  var _useDebouncedChange = (0, _useDebouncedChange3["default"])(handleChange, '', data, path, eventToValue),
      _useDebouncedChange2 = _slicedToArray(_useDebouncedChange, 2),
      inputValue = _useDebouncedChange2[0],
      onChange = _useDebouncedChange2[1];

  return /*#__PURE__*/_react["default"].createElement(_core.Input, {
    type: "number",
    value: inputValue,
    onChange: onChange,
    className: className,
    id: id,
    disabled: !enabled,
    autoFocus: appliedUiSchemaOptions.focus,
    inputProps: inputProps,
    fullWidth: true,
    startAdornment: startAdornment,
    endAdornment: endAdornment
  });
});

var _default = MuiInputNumber;
exports["default"] = _default;